import { useTranslation } from 'react-i18next'

import translationKeys from '@translationKeys'

import pOnePlusLogo from '@assets/images/logo.png'

import { StyledMainLogo } from './index.styles'

export type MainLogoProps = {
  altText?: string
  src?: string
  dataTestId?: string
}

const MainLogo = ({
  altText = translationKeys.MAIN_LOGO_ALT_TEXT,
  src = pOnePlusLogo,
  dataTestId = 'main-logo',
}: MainLogoProps) => {
  const { t } = useTranslation()
  const altImgTxt = t(altText) || ''
  return <StyledMainLogo src={src} alt={altImgTxt} data-testid={dataTestId} />
}

export default MainLogo
